var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlNavBarMv',{staticClass:"faq-header",attrs:{"title":_vm.title,"has-back-button":"","data-testid":"faq-header"},on:{"handleBackButtonClick":_vm.toPreviousPage}})}
var staticRenderFns = []

export { render, staticRenderFns }